import React, { useEffect, useState } from "react";
import { allTours } from "../../../api/admin/tourApi";

const MultiTourSelector = ({ setFormData, sectionIndex }) => {
  const [Data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Show, setShow] = useState(false);
  const [Search, setSearch] = useState("");
  const [selectedTour, setSelectedTour] = useState("");
  useEffect(() => {
    allTours(setData);
  }, []);
  const handleShow = () => {
    setShow(!Show);
  };
  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(Data);
    } else {
      const result = Data.filter((item) =>
        item.tourName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, Data]);
  const handleSelect = (item) => {
    const { tourId, tourName } = item;

    setFormData((prevData) => {
      const newData = [...prevData];
      const exists = newData[sectionIndex].selectedTours.some(
        (h) => h.tourId === tourId,
      );
      if (!exists) {
        newData[sectionIndex].selectedTours.push({ tourId, tourName });
      }
      return newData;
    });

    setSelectedTour(item);
    setShow(false);
  };
  return (
    <div className="w-full relative">
      <div
        onClick={handleShow}
        className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm cursor-pointer select-none flex justify-start items-center gap-3"
      >
        {selectedTour ? (
          <>
            <div className="flex gap-x-2 justify-start items-center">
              <p className="text-sm font-medium uppercase">
                {selectedTour.tourName}
              </p>
            </div>
          </>
        ) : (
          <div>
            <p>Select Tours</p>
          </div>
        )}
      </div>
      {Show && (
        <div className="bg-white w-full max-h-[300px] overflow-y-auto p-3 absolute top-10 drop-shadow-lg left-1/2 -translate-x-1/2 rounded-lg z-10 border scrollbar-hide">
          <div className="space-y-3">
            <div>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                placeholder="Search tour by name"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
              />
            </div>
            <div>
              {filteredData.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => handleSelect(item)}
                    className="flex gap-2 justify-start items-center bg-white hover:bg-[#d7eaff] p-2 rounded-lg cursor-pointer"
                  >
                    <div className="flex gap-x-2 justify-start items-center">
                      <p className="text-sm font-medium uppercase">
                        {item.tourName}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiTourSelector;
